// export const context = "/_api";
export const context = window.publicServiceDomain || ""
export const manage = window.manage || ""
export const deleteBz = window.deleteBz || ""

export const API = {
    // 初始化数据
    serInit: window.publicInitApi,
    // serInit: context + "/ai-helper/init",
    newChat: context + "/ai-helper/znt/newChat",
    sessionList: context + "/ai-helper/znt/chat/session/list",
    deleteChat: context + "/ai-helper/znt/chat/delete",
    updateChat: context + "/ai-helper/znt/chat/update",
    // 智能问答
    serSocket: `${window.publicAIDomain}/qa`,
    // 自动输入
    serAutoComplete: context + "/ai-helper/ai-tips",
    // 同意
    serAgree: context + "/ai-helper/agree",
    categaryList: context + "/ai-helper/znt/list?categoryId=",
    categary: context + "/ai-helper/znt/category",
    // 评价
    serEvaluate: context + "/ai-helper/score",
    zntHistory:
        (process.env.NODE_ENV === "development" ? "/_bkdApi" : "") + "/aiqa/ai-helper/znt/chatHistroy",
    zntSearch:
        (process.env.NODE_ENV === "development" ? "/_bkdApi" : "") + "/aiqa/ai-helper/znt/search",
    // 免责声明（已废弃）
    serDisclaimer: context + "/_web/apps/wdzsk/dataopen/api/znwd.rst",
    // 快捷短语（已废弃）
    serReplies: context + "/_web/apps/wdzsk/dataopen/api/tjzts.rst",
    // 服务导办（已废弃）
    serGuide: context + "/_web/apps/wdzsk/dataopen/api/fwyys.rst",
    sessionHistory: context + "/ai-helper/znt/chat/history",
    // 智能问答（已废弃）
    socket: "ws://8.131.59.22:83/websocket",
    // 自动输入（已废弃）
    autoComplete: "/chat-service/autocomplete",
    //获取对话列表
    getChatList: context + "/ai-helper/history",
    //获取帮助信息
    getHelpInfo: context + "/ai-helper/znt/helpInfo",
    //录音
    audioSocket: `${window.publicAudioApi}`,
    //文件下载
    downDocs: context + "/ai-helper/znt/doc/download",
    //文件上传
    uploadDocs: context + "/ai-helper/znt/doc/upload",
    //问答附件下载
    askDownLoadDocs: context + "/ai-helper/znt/doc/temp/show",
    //获取对话管理数据
    getChatManageData: manage + "/api/chatSessionlogs.rst",
    //处理对话数据
    handleChatStatus: manage + "/api/handleSetting.rst",
    //删除标注
    deleteBz: deleteBz + "/api/markzss.rst",

}

export function getInitData(parameters = {}) {
    return {
        url: API.serInit,
        method: "get",
        params: parameters,
    }
}
export function getcategaryList(type = "") {
    return {
        url: API.categaryList + (type === "0" ? "" : parseInt(type)),
        method: "get",
    }
}
export function getSessionList(params = { zntId: '', count: "" }) {
    return {
        url: API.sessionList,
        method: "get",
        params
    }
}
export function getNewChat(params) {
    return {
        url: API.newChat,
        method: "get",
        params,
    }
}
export function getDeleteChat(chatId) {
    return {
        url: API.deleteChat + "?chatId=" + chatId,
        method: "get",
    }
}
export function getZntHistory() {
    return {
        url: API.zntHistory,
        method: "get",
    }
}
export function getZntSearch(params = "") {
    return {
        url: API.zntSearch + "?name=" + params,
        method: "get",
    }
}
export function getcategary() {
    return {
        url: API.categary,
        method: "get",
    }
}
export function getUpdateChat(params) {
    return {
        url: API.updateChat,
        method: "get",
        params,
    }
}
export function getAgreeData(parameters = {}) {
    return {
        url: API.serAgree,
        method: "get",
        params: parameters,
    }
}

export function getEvaluateData(parameters = {}) {
    return {
        url: API.serEvaluate,
        method: "post",
        data: parameters,
    }
}

export function getDisclaimersData(parameters = {}) {
    return {
        url: API.serDisclaimer,
        method: "get",
        params: parameters,
    }
}

export function getRepliesData(parameters = {}) {
    return {
        url: API.serReplies,
        method: "post",
        data: parameters,
    }
}

export function getGuideData(parameters = {}) {
    return {
        url: API.serGuide,
        method: "post",
        data: parameters,
    }
}

export function getChatList(parameters = { id: "", date: "", count: 10 }) {
    return {
        url:
            API.getChatList +
            `?znwdId=${parameters?.id}&date=${parameters?.date}&count=${parameters?.count}`,
        method: "get",
    }
}
export function getSessionHistory(chaId) {
    return {
        url: API.sessionHistory + `?chatId=${chaId}`,
        method: "get",
    }
}

export function getHelpInfo(chaId) {
    return {
        url: API.getHelpInfo + `?zntId=${chaId}`,
        method: "get"
    }
}
